import { BarLoader } from "react-spinners";

const CommonLoading = () => {
  return <BarLoader color="#FA8112" height={4} width={120} />;
};

export default CommonLoading;
